import { useEffect, useRef, useState } from "react";
import sampleimg from "../../../assets/sample-blog-img.jpg";
import "../branding/BrandingDetails.css";
import Header from "../../Header";
import PageTransition from "../../../PageTransition";
import cybernetyximg2 from './img/cybernetyx-2.webp'
import cybernetyximg3 from './img/cybernetyx-3.webp'
import cybernetyximg4 from './img/cybernetyx-4.webp'
import cybernetyximg5 from './img/cybernetyx-5.webp'
import cybernetyximg6 from './img/cybernetyx-6.webp'
import cybernetyximg7 from './img/cybernetyx-7.webp'
import cybernetyximg8 from './img/cybernetyx-8.webp'
import cybernetyximg9 from './img/cybernetyx-9.webp'
import cybernetyximg10 from './img/cybernetyx-10.webp'
import cybernetyximg11 from './img/cybernetyx-11.webp'
import cybernetyximg12 from './img/cybernetyx-12.webp'
import cybernetyximg13 from './img/cybernetyx-13.webp'
import cybernetyximg14 from './img/cybernetyx-14.webp'
const MEDIA = [
  {
    type: "video",
    youtubeId: "HW8wQ9oNqZc",
  },
  {
    type: "image",
    src: cybernetyximg3,
  },
  {
    type: "image",
    src: cybernetyximg4,
  },
  {
    type: "image",
    src: cybernetyximg5,
  },
  {
    type: "image",
    src: cybernetyximg6,
  },
  {
    type: "image",
    src: cybernetyximg7,
  },
  {
    type: "image",
    src: cybernetyximg8,
  },
  {
    type: "image",
    src: cybernetyximg9,
  },
  {
    type: "image",
    src: cybernetyximg10,
  },
  {
    type: "image",
    src: cybernetyximg11,
  },
  {
    type: "image",
    src: cybernetyximg12,
  },
  {
    type: "image",
    src: cybernetyximg13,
  },
  {
    type: "image",
    src: cybernetyximg14,
  },
];

export default function Cybernetyx() {
  const [index, setIndex] = useState(0);
  const railRef = useRef(null);
  const trackRef = useRef(null);
  const iframeRef = useRef(null);

  const isAnimating = useRef(false);
  const startX = useRef(0);
  const touchStartX = useRef(0);

  const isMobile = window.innerWidth <= 768;

  /* ================= SLIDE ================= */
  const slideTo = (next) => {
    if (next < 0 || next >= MEDIA.length) return;
    if (isAnimating.current) return;

    isAnimating.current = true;
    setIndex(next);
    setTimeout(() => (isAnimating.current = false), 700);
  };

  /* ================= STOP VIDEO ON SLIDE ================= */
  useEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow?.postMessage(
        '{"event":"command","func":"pauseVideo","args":""}',
        "*"
      );
    }
  }, [index]);

  /* ================= WHEEL ================= */
  useEffect(() => {
    if (isMobile) return;

    const onWheel = (e) => {
      e.preventDefault();
      if (e.deltaY > 0) slideTo(index + 1);
      if (e.deltaY < 0) slideTo(index - 1);
    };

    window.addEventListener("wheel", onWheel, { passive: false });
    return () => window.removeEventListener("wheel", onWheel);
  }, [index, isMobile]);

  /* ================= DRAG ================= */
  const onMouseDown = (e) => {
    startX.current = e.clientX;
  };

  const onMouseUp = (e) => {
    const delta = e.clientX - startX.current;
    if (delta > 80) slideTo(index - 1);
    if (delta < -80) slideTo(index + 1);
  };

  /* ================= TOUCH ================= */
  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const onTouchEnd = (e) => {
    const delta = e.changedTouches[0].clientX - touchStartX.current;
    if (Math.abs(delta) < 60) return;
    if (delta < 0) slideTo(index + 1);
    if (delta > 0) slideTo(index - 1);
  };

  /* ================= TRANSLATE ================= */
  const getTranslateX = () => {
    if (!railRef.current) return 0;
    const card = railRef.current.querySelector(".branding-detail-card");
    if (!card) return 0;

    const gap = window.innerWidth <= 768 ? 16 : 42;
    return index * (card.offsetWidth + gap);
  };

  return (
    <>
      <Header visible mode="normal" />
      <PageTransition>
        <main className="branding-detail-page">
          {/* HERO */}
          <section className="branding-detail-hero">
            <h1>Cybernetyx</h1>
            <p>
              Covered and produced a 3 day event into visuals at BrightClassan
              AI-powered interactive learning ecosystem.
            </p>
          </section>

          {/* SLIDER */}
          <section
            className="branding-detail-rail"
            ref={railRef}
            onMouseDown={!isMobile ? onMouseDown : undefined}
            onMouseUp={!isMobile ? onMouseUp : undefined}
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
          >
            <div
              className="branding-detail-track"
              ref={trackRef}
              style={{
                transform: `translateX(-${getTranslateX()}px)`,
              }}
            >
              {MEDIA.map((item, i) => (
                <div className="branding-detail-card" key={i}>
                  {item.type === "video" ? (
                    <div className="branding-detail-video">
                      <iframe
                        ref={iframeRef}
                        src={`https://www.youtube.com/embed/${item.youtubeId}?enablejsapi=1&rel=0&modestbranding=1`}
                        title="Cybernetyx Event Video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      />
                    </div>
                  ) : (
                    <div
                      className="branding-detail-image"
                      style={{
                        backgroundImage: `url(${item.src})`,
                      }}
                    />
                  )}
                </div>
              ))}
            </div>

            <div className="branding-detail-shadow" />
          </section>
        </main>
      </PageTransition>
    </>
  );
}
